import React from "react";

// XListsCTA — small badge that surfaces @GlobalEyesDOTtv's X lists when a
// viewer is looking at a geo-tagged moment. The handle maintains a list per
// country + most US cities, so the relevant list helps viewers stay subscribed
// to live updates from a region they care about.
//
// We don't have a precise city/country → list-id mapping baked in (lists move,
// and the user maintains 200+ of them on X). Instead we point at the lists
// overview filtered by URL hash with the country/city pre-populated for search.
// X's UI will land the user on the catalog where they can click their region.

const XListsCTA = ({ city, country, className = "", variant = "inline" }) => {
  const place = [city, country].filter(Boolean).join(", ");
  if (!place) return null;

  // X doesn't support a deep-link search inside one account's lists, so the
  // best UX is: open the lists overview + tell the user what to look for.
  const href = `https://x.com/GlobalEyesDOTtv/lists`;
  const title = `Follow live updates from ${place} on X — pick the ${country || "country"} list`;

  if (variant === "compact") {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title={title}
        className={`inline-flex items-center gap-1 text-[11px] text-gray-400 hover:text-emerald-400 transition-colors ${className}`}
        data-testid="x-lists-cta-compact"
      >
        <span className="font-bold leading-none">𝕏</span>
        <span>Follow {place} list →</span>
      </a>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-gray-700 bg-gray-900/80 hover:border-emerald-500 hover:bg-emerald-900/30 text-gray-200 hover:text-emerald-300 text-xs transition-colors ${className}`}
      data-testid="x-lists-cta"
    >
      <span className="font-bold leading-none">𝕏</span>
      <span>Follow <strong>{place}</strong> on @GlobalEyesDOTtv lists →</span>
    </a>
  );
};

export default XListsCTA;
